import { render, staticRenderFns } from "./verbaliRecenti.vue?vue&type=template&id=51e06d2e"
import script from "./verbaliRecenti.vue?vue&type=script&lang=js"
export * from "./verbaliRecenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports